import { reduxKey } from './constants';
import {
  initialize,
  requestFailure,
  requestSuccess,
  submitSuccess,
} from './actionCreators';
import { ReportPageStoreSlice } from './types';

const actionHandlers = {
  [initialize.toString()]: (state: ReportPageStoreSlice, action) => ({
    ...state,
    isLoading: true,
    isError: false,
  }),

  [requestFailure.toString()]: (state: ReportPageStoreSlice, action) => ({
    ...state,
    isLoading: false,
    isError: true,
  }),

  [requestSuccess.toString()](
    state: ReportPageStoreSlice,
    { payload }
  ): ReportPageStoreSlice {
    return {
      ...state,
      isLoading: false,
      data: payload.data,
    };
  },

  [submitSuccess.toString()]: (state: ReportPageStoreSlice, action) => ({
    ...state,
    // after a submission, clear any previous init data so it's fetched again
    // if the report modal is opened - even if the page isn't refreshed -
    // this way, we can prevent report types being submitted more than once
    data: undefined,
  }),
};

const reducers = {
  // cast "as string" because of TS
  [reduxKey as string](state = {}, action) {
    const { type, payload } = action;
    if (!actionHandlers[type]) {
      return state;
    }

    // each deviationId gets it's own mini-slice of the store
    const stateKey = payload.deviationId;
    return {
      ...state,
      [stateKey]: actionHandlers[type](state[stateKey], action),
    };
  },
};

export default reducers;
